import { PercentPipe } from '@angular/common';
import type { PipeTransform } from '@angular/core';
import { inject, Pipe } from '@angular/core';

import { BaseDirective } from '@valk-nx/core/lib/directives/base/base.directive';

@Pipe({
	name: 'percentage',
	pure: true,
})
export class PercentagePipe extends BaseDirective implements PipeTransform {
	private readonly percentPipe = inject(PercentPipe);

	transform(percentage: number): string | null {
		return this.percentPipe.transform(
			percentage / 100,
			undefined,
			this.language(),
		);
	}
}
